import React, { FunctionComponent, } from 'react';
import {
  Button,
  Card,
  CardContent,
} from '@mui/material';
import { AppDispatch, } from '../../store/store';
import { useTranslation, } from 'react-i18next';
import { useDispatch, } from 'react-redux';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { Container } from '@mui/system';
import SuccessMessage from '../../components/SuccessMessage/SuccessMessage';

import './VerifySuccess.css';
import useTitle from '../../helpers/use-title';
import {redirectBack} from "../../store/middlewares/redirect";
import { push } from '@lagunovsky/redux-react-router';

const VerifySuccess: FunctionComponent = () => {

  const { t } = useTranslation( [ 'verifySuccess' ] );
  const { t: tCommon } = useTranslation( [ 'common' ] );

  const dispatch = useDispatch<AppDispatch>();

  const onClick = () => {

    // TODO: For the time being we use push instead redirectBack
    // since macs365 is right now using the logout_uri param to refer hgskey itself once again

    // dispatch( redirectBack());

    dispatch( push( '/' ) );
  }

  useTitle( tCommon( 'your-user-profile' ) );

  return (
    <AppLayout title={ tCommon( 'your-user-profile' ) }>
      <div className="page page-email-migration">
        <Container>
          <Card sx={ { mt: 4 } }>
            <CardContent>
              <SuccessMessage header={ t( 'change-of-email-address-successful' ) }>
                <p>
                  { t( 'from-now-on-we-will-send-you-messages' ) }
                </p>
                <p>
                  <strong>{ t( 'keep-in-mind-that-this-email' ) }</strong>
                </p>
                <Button
                onClick={ onClick }
                  variant='contained'
                >{ tCommon( 'go-to-login' ) }</Button>
              </SuccessMessage>
            </CardContent>
          </Card>
        </Container>
      </div>
    </AppLayout>
  );
}

export default VerifySuccess;
